import {Injectable} from '@angular/core';

@Injectable()
export class AlertService {
    public activate: (message?: string, title?: string, okText?: string) => Promise<boolean>;
}